import React from 'react'
import { Link } from 'gatsby'
import NewsHome from '../../News/NewsHome'
import { Container, Row, Col } from 'reactstrap'

import { addresses } from '../../../utils/variables'

const HomeActus = () => {
	return (
		<section 
			className="home-slice home-slice-news"
			role="region"
			aria-label="Section actualités de la page d'accueil"
			aria-labelledby="home-actus-heading"
		>
		<Container>
			<Row>
				<Col sm="12" lg="6">
					<h1 id="home-actus-heading" className="section-title h1-like">
						<span>Les actualités</span> à la une
					</h1>
				</Col>
				<Col sm="12" lg="6">
					<p className="section-link text-lg-right mt-1 mt-lg-4">
						<a 
							className="news-home-all-link" 
							target="_blank" 
							rel="noopener noreferrer" 
							href={addresses['roubaixxl']}
							aria-label="Voir plus d'actualités sur roubaixxl.fr (s'ouvre dans un nouvel onglet)"
						>
							Voir plus d'actualités sur roubaixxl.fr
						</a>
					</p>
				</Col>
			</Row>
			<NewsHome />
			<p className='news-list-item-external'>
				<Link 
					to='/toutes-les-publications/' 
					className='news-list-item-external-link'
					aria-label="Accéder à votre magazine ROUBAIXXL en ligne : tous les numéros en un clic"
				>
					Votre magazine ROUBAIXXL en ligne : tous les numéros en un clic
				</Link>
			</p>
		</Container>
		</section>
	)
}

export default HomeActus
